import { render, staticRenderFns } from "./ContentButton.vue?vue&type=template&id=7165b24d&scoped=true&"
import script from "./ContentButton.vue?vue&type=script&lang=js&"
export * from "./ContentButton.vue?vue&type=script&lang=js&"
import style0 from "./ContentButton.vue?vue&type=style&index=0&id=7165b24d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7165b24d",
  null
  
)

export default component.exports